<template>
  <el-dialog
    append-to-body
    width="900px"
    title="申请记录"
    :visible.sync="visible"
    :before-close="reset"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    destroy-on-close
  >
    <el-form ref="elFormDom" inline :model="search" :size="subUnitSize">
      <el-form-item label="开票单位" prop="invoice_company_id">
        <el-select
          v-model="search.invoice_company_id"
          placeholder="请选择"
          clearable
          filterable
        >
          <el-option
            v-for="item in invoiceCompanyOpt"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="发放日期" prop="issued_day">
        <el-date-picker
          v-model="search.issued_day"
          type="date"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSearch">查询 </el-button>
        <el-button @click="resetSearch">重置</el-button>
      </el-form-item>
    </el-form>
    <el-table
      style="margin-top: 10px"
      class="m-b-10"
      border
      :data="tableData"
      height="450"
      v-loading="loading"
    >
      <el-table-column
        type="index"
        label="序号"
        align="center"
        width="50"
        fixed
      >
      </el-table-column>
      <el-table-column
        label="开票单位"
        prop="invoice_company_name"
        show-overflow-tooltip
        min-width="120"
        align="center"
      >
      </el-table-column>
      <el-table-column
        label="实发金额"
        prop="total_salary"
        show-overflow-tooltip
        min-width="120"
        align="center"
      >
        <template #default="{ row }">
          <span>￥{{ row.total_salary }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="发放日期"
        prop="issued_day"
        show-overflow-tooltip
        min-width="120"
        align="center"
      >
      </el-table-column>
      <el-table-column
        label="状态"
        prop="status"
        show-overflow-tooltip
        min-width="80"
        align="center"
      >
        <template #default="{ row }">
          {{ { 1: "已撤销", 2: "待发放", 3: "已发放" }[row.status] }}
        </template>
      </el-table-column>
      <el-table-column
        label="申请时间"
        prop="created_at"
        show-overflow-tooltip
        min-width="150"
        align="center"
      >
        <template #default="{ row }">
          {{ row.created_at.slice(0, -3) }}
        </template>
      </el-table-column>
      <el-table-column
        label="创建人"
        prop="creator_name"
        show-overflow-tooltip
        min-width="100"
        align="center"
      >
      </el-table-column>
      <el-table-column width="1"></el-table-column>
      <el-table-column
        label="操作"
        prop="action"
        min-width="60"
        align="center"
        fixed="right"
      >
        <template #default="{ row }">
          <!-- <el-popconfirm @confirm="deteteRow(row)" title="确定删除吗？">
            <el-button type="text" slot="reference">删除</el-button>
          </el-popconfirm> -->
          <el-button type="text" @click="viewDetail(row)">查看</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      :small="true"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.total"
      :page-size="page.count"
      :currentPage="page.page"
      @current-change="currentPageChange"
      @size-change="pageSizeChange"
    ></el-pagination>
    <template #footer>
      <el-row type="flex" justify="center">
        <el-button @click="toggle(false)">关闭</el-button>
        <!-- <el-button type="primary" @click="confirm">确定</el-button> -->
      </el-row>
    </template>
    <applyPaymentDialog ref="applyPaymentDialogRef"></applyPaymentDialog>
  </el-dialog>
</template>

<script>
import applyPaymentDialog from "./applyPaymentDialog.vue";
import { mapGetters } from "vuex";
export default {
  components: { applyPaymentDialog },
  data() {
    return {
      subUnitSize: this.$store.state.subUnitSize, // 获取组件 size属性
      visible: false,
      loading: false,
      info: {},
      disabled_titles: [],
      search: {
        invoice_company_id: "",
        issued_day: "",
      },
      page: {
        page: 1,
        count: 20,
        total: 0,
      },
      tableData: [],
    };
  },
  methods: {
    // 获取详情
    getDetail(row) {
      this.info = row;
      // 使用深拷贝避免修改原始数据
      this.getData();
    },
    getData() {
      let params = {
        page: this.page.page,
        count: this.page.count,
        ...this.search,
        year: this.info.year,
        month: this.info.month,
      };
      this.loading = true;
      this.$http
        .post(`/admin/finance/paymentList`, params)
        .then((res) => {
          if (res.code == 1) {
            this.tableData = res.data.list;
            this.page.total = res.data.total;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onSearch() {
      this.getData();
    },
    resetSearch() {
      this.$refs.elFormDom.resetFields();
      this.page = {
        page: 1,
        count: 20,
        total: 0,
      };
      this.getData();
    },
    currentPageChange(val) {
      this.page.page = val;
      this.getData();
    },
    pageSizeChange(val) {
      this.page.count = val;
      this.page.page = 1;
      debugger;
      this.getData();
    },
    reset(done) {
      this.page = {
        page: 1,
        count: 20,
        total: 0,
      };
      this.$refs.elFormDom.resetFields();
      this.$emit("refresh");
      done && done();
    },
    toggle(show) {
      this.visible = show;
      !show && this.reset();
    },
    // 提交
    confirm() {},
    deteteRow(row) {
      this.$http
        .post("/admin/finance/delPayment", { id: row.id })
        .then((res) => {
          if (res.code == 1) {
            this.$message.success("删除成功");
            this.getData();
          }
        });
    },
    viewDetail(row) {
      let dom = this.$refs.applyPaymentDialogRef;
      dom.toggle(true);
      dom.getDetail([], row.id);
    },
  },
  computed: {
    ...mapGetters({
      invoiceCompanyOpt: "invoiceCompany", // 获取开票单位列表
    }),
  },
};
</script>
<style scoped lang="scss">
::v-deep .el-table__body-wrapper {
  &::-webkit-scrollbar {
    height: 6px;
    width: 6px;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 40px;
    background-color: #8d8d8d;
    box-shadow: 8px 0 0 #a5adb7 inset;
    &:hover {
      box-shadow: 8px 0 0 #4a4a4a inset;
    }
  }
}
::v-deep .el-table__header-wrapper {
  &::-webkit-scrollbar {
    height: 6px;
    width: 6px;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 40px;
    background-color: #8d8d8d;
    box-shadow: 8px 0 0 #a5adb7 inset;
    &:hover {
      box-shadow: 8px 0 0 #4a4a4a inset;
    }
  }
}
</style>